<template>
    <v-container fluid fill-height pa-0 class="overlay">
        <div class="loader">
            <v-progress-circular
                :size="50"
                color="amber"
                indeterminate
            ></v-progress-circular>
        </div>
        <v-dialog v-model="dialog" persistent content-class="modal-dialog">
            <v-card class="modal-info">
                <div class="common-text mb-2"> Вы уже заселены в номер </div>
                <div class="main-text mb-5"> Хотите заселиться заново? </div>
                <v-flex class="d-flex justify-end w-100 mt-6">
                    <v-btn class="btn-gradient main-text mr-2" @click="updateToken">
                        Заселить
                    </v-btn>
                    <v-btn class="btn-grey main-text" @click="close">
                        Отмена
                    </v-btn>
                </v-flex>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
export default {
    name: 'MasterPage',
    data() {
        return {
            truth: false,
            dialog: false,
        };
    },
    created() {
        if (!this.$store.state.accessToken) {
            this.$nextTick(() => {
                this.getAccessKey();
            });
        }
        if (this.$route.query.master_key) {
            this.checkToken();
        }
    },
    methods: {
        getAccessKey() {
            if (this.$route.query.master_key) {
                this.$http.post('/hotels/guest/get-room-access-key/', {
                    master_key: this.$route.query.master_key,
                })
                    .then((response) => {
                        localStorage.RobohotelTableDataAccessToken = response.data.key;
                        // this.$router.go( 0);
                        // this.$router.push( '/');
                        this.$nextTick(() => {
                            this.$router.go( 0);
                            this.$router.replace({name: "devicelist", query: null, params: null});
                        });
                    })
                    .catch((error) => {
                        console.log(error);
                        this.$router.push({ name: "empty" });
                    });
            } else {
                this.$router.push({ name: "error" });
            }
        },
        checkToken() {
            if (this.$store.state.accessToken) {
                this.$http.get('/hotels/guest/profile/')
                    .then((response) => {
                        if (response.data) {
                            this.dialog = true;
                        } else {
                            this.updateToken();
                        }
                    })
                    .catch(() => {
                        this.updateToken();
                    });
            } else {
                this.updateToken();
            }
        },
        updateToken() {
            localStorage.removeItem("RobohotelTableDataAccessToken");
            this.$nextTick(() => {
                this.getAccessKey();
            });
        },
        close() {
            this.dialog = false;
            this.$router.replace({name: "devicelist", query: null, params: null});
        },
    }
}
</script>

<style lang="scss" scoped>
.overlay {
    z-index: 100;
    position: absolute;
    background: #FFFFFF;

    .loader {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
    }
}

.modal-info.v-card {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
}

.v-btn {
    max-width: 94px;
    text-transform: none;
}

.w-100 {
    width: 100%;
}
</style>